"use client";

import React from "react";

//Styles
import * as S from "./styles";
import { ButtonTootipIconProps } from "@/types";
import { Tooltip, TooltipContent } from "../ui/tooltip";

const ButtonTootipIcon: React.FC<ButtonTootipIconProps> = ({
  variant,
  icon,
  textButton,
  textTootip,
  onClick,
}) => {
  return (
    <Tooltip>
      <S.ButtonArround $variant={variant} onClick={onClick}>
        {icon} {textButton}
      </S.ButtonArround>
      <TooltipContent>{textTootip}</TooltipContent>
    </Tooltip>
  );
};

export default ButtonTootipIcon;
